import React, { useCallback } from "react";
import { useFormik } from "formik";
import { Trans } from "react-i18next";
import { Input } from "../../../components/simple/Input";
import { CashBackValidation } from "./validationSchema";
import i18n from "../../../i18n";
import {
  useGetProductsQuery,
  // useGetRegionsQuery,
  useGetActivitiesQuery,
  useGetPhonePrefixesQuery,
  // useGetPosTerminalTypesQuery,
} from "../../../api";
import { fetchCreateApplication } from "../../../api/application.api";
import { history, PRODUCTS_IMG_URLS } from "../../../helpers/history";
import { Column, Grid, Row } from "carbon-components-react";
import { LbSelect } from "../../../components/simple/LbSelect";
import { Phone } from "../../../components/simple/Phone";
import LbCheckBox from "../../../components/simple/LbCheckBox";

export const Index = () => {
  const {
    data: activities,
    isError: isActivityError,
    isLoading: isActivityLoading,
  } = useGetActivitiesQuery();
  const { data: phoneOptions, isLoading: isPhoneOptionsLoading } =
    useGetPhonePrefixesQuery();

  const { data, isLoading, isError, error } = useGetProductsQuery();

  const productImgs = PRODUCTS_IMG_URLS.slice(0, 2);

  const formik = useFormik({
    initialValues: {
      productTypes: [],
      partnershipInPOS: false,
      partnershipInElCommerse: false,
      contactName: "",
      contactPhone: "",
      contactEmail: "",
      companyCode: "",
      companyName: "",
      companyWebSite: "",
      activityCodes: {},
      phonePrefixes: {
        code: "+995",
        country: "Georgia",
        exampleNumber: i18n.t("Common.Phone.Placeholder"),
        format: "(?:5(?:[14]4|5[0157-9]|68|7[0147-9]|9[1-35-9])|790)\\d{6}",
        id: "GE",
        label: "+995",
        value: "GE",
      },
      agree: false,
      cashbackActivityCode: null,
    },
    validationSchema: CashBackValidation,
    onSubmit: async (values, methods) => {
      const { setSubmitting, resetForm } = methods;
      try {
        setSubmitting(true);
        await fetchCreateApplication({
          ...values,
          productTypes: ["CASHBACK"],
        });
        resetForm();
        setSubmitting(false);
        history.push("/application/create/complete", {
          type: "success",
          productType: "CASHBACK",
        });
      } catch (error) {
        history.push("/application/create/complete", {
          type: "error",
          productType: "CASHBACK",
        });
      }
    },
  });

  const handleActivity = useCallback(
    async (val, product) => {
      const formikProperty = {
        CASHBACK: "cashbackActivityCode",
      };
      let { activityCodes } = formik.values;

      activityCodes[product] = val.value;
      await formik.setFieldValue("activityCodes", activityCodes);

      await formik.setFieldValue(formikProperty[product], val);
    },
    [formik]
  );

  const handlePrefix = useCallback(
    async (val) => {
      await formik.setFieldValue("phonePrefixes", val);
    },
    [formik]
  );

  const handelAgree = useCallback(
    async (e) => {
      // console.log("preventDefault", e);
      // e.preventDefault();
      await formik.setFieldValue("agree", !formik.values.agree);
    },
    [formik]
  );

  const handleToggleProduct = useCallback(
    async (product) => {
      const productTypes = [...formik.values.productTypes];

      if (productTypes.includes(product)) {
        await formik.setFieldValue(
          "productTypes",
          productTypes.filter((i) => i !== product)
        );

        await formik.setFieldValue(
          product === "ECOMERCE"
            ? "partnershipInElCommerse"
            : "partnershipInPOS",
          false
        );
      } else {
        productTypes.push(product);
        await formik.setFieldValue("productTypes", productTypes);
        await formik.setFieldValue(
          product === "ECOMERCE"
            ? "partnershipInElCommerse"
            : "partnershipInPOS",
          true
        );
      }
    },
    [formik]
  );

  return (
    <Grid>
      <Row>
        <Column lg={12}>
          <div className="lb-product-selection">
            {/* ქეშბექში */}
            <div className="mb-64">
              <h4 className="productive-heading-04 mb-24">
                <Trans i18nKey="Application.CashBack.Title" />
              </h4>

              <p
                dangerouslySetInnerHTML={{
                  __html: i18n.t("Application.CashBack.Description.Small", {
                    pos: "/pos",
                    eCommerce: "/e-commerce",
                  }),
                }}
              ></p>
            </div>

            <div className="img-container cashback">
              {productImgs.map(
                (product) =>
                  data.includes(product.key) && (
                    <div
                      className="card"
                      key={`product-${product.key}`}
                      // onClick={() => handleToggleProduct(product.key)}
                    >
                      <img src={product.img} alt="" />
                      <p>
                        <Trans i18nKey={`Application.Product.${product.key}`} />
                      </p>
                      <label className="card__checkbox">
                        <input
                          type="checkbox"
                          name="productType[]"
                          value={product.key}
                          onClick={() => handleToggleProduct(product.key)}
                          checked={formik.values.productTypes.includes(
                            product.key
                          )}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  )
              )}
            </div>

            {formik.values.productTypes.length ? (
              <div className="la-electronic-commerce mr-auto ml-auto">
                <Input
                  label={i18n.t("Application.contactName")}
                  value={formik.values.contactName}
                  onChange={formik.handleChange("contactName")}
                  onBlur={formik.handleBlur("contactName")}
                  error={
                    "contactName" in formik.errors &&
                    "contactName" in formik.touched
                  }
                />

                <Phone
                  phoneOptions={phoneOptions}
                  isLoading={isLoading}
                  label={i18n.t("Application.Pos.contactPhone")}
                  placeholder={
                    (formik.values.phonePrefixes &&
                      formik.values.phonePrefixes.exampleNumber) ||
                    i18n.t("Application.Pos.contactPhone.Placeholder")
                  }
                  name="contactPhone"
                  value={formik.values.contactPhone}
                  prefixValue={formik.values.phonePrefixes}
                  onChange={formik.handleChange("contactPhone")}
                  onPrefixChange={handlePrefix}
                  onBlur={formik.handleBlur("contactPhone")}
                  error={
                    "contactPhone" in formik.errors &&
                    "contactPhone" in formik.touched
                  }
                />

                <Input
                  label={i18n.t("Application.contactEmail")}
                  value={formik.values.contactEmail}
                  onChange={formik.handleChange("contactEmail")}
                  onBlur={formik.handleBlur("contactEmail")}
                  error={
                    "contactEmail" in formik.errors &&
                    "contactEmail" in formik.touched
                  }
                />

                <Input
                  label={i18n.t("Application.companyName")}
                  value={formik.values.companyName}
                  onChange={formik.handleChange("companyName")}
                  onBlur={formik.handleBlur("companyName")}
                  error={
                    "companyName" in formik.errors &&
                    "companyName" in formik.touched
                  }
                />

                <Input
                  label={i18n.t("Application.companyCode")}
                  value={formik.values.companyCode}
                  onChange={formik.handleChange("companyCode")}
                  onBlur={formik.handleBlur("companyCode")}
                  error={
                    "companyCode" in formik.errors &&
                    "companyCode" in formik.touched
                  }
                  placeholder={i18n.t("Application.companyCode.Placeholder")}
                />

                <Input
                  regex="[a-zA-Z]"
                  label={i18n.t("Application.companyWebSite")}
                  value={formik.values.companyWebSite}
                  onChange={formik.handleChange("companyWebSite")}
                  onBlur={formik.handleBlur("companyWebSite")}
                  error={
                    "companyWebSite" in formik.errors &&
                    "companyWebSite" in formik.touched
                  }
                />

                <LbSelect
                  options={
                    activities &&
                    activities.filter((i) => i.productType === "CASHBACK")
                  }
                  isLoading={isActivityLoading}
                  label={i18n.t("Application.CashBack.activityCodes")}
                  value={formik.values.cashbackActivityCode}
                  onChange={(val) => handleActivity(val, "CASHBACK")}
                  onBlur={formik.handleBlur("cashbackActivityCode")}
                  placeholder={i18n.t("Application.CashBack.CashbackActivity")}
                  // menuIsOpen={true}
                />

                <div className="agreement-terms mb-32">
                  <p className="agreement-terms__details code-02">
                    {i18n.t("Application.Pos.AgreeRules")}
                  </p>
                  <LbCheckBox
                    id="Application.AcceptRules.agree"
                    i18nKey="Application.AcceptRules"
                    name="agree"
                    value={formik.values.agree}
                    checked={!!formik.values.agree}
                    onLabelClick={handelAgree}
                    onChange={handelAgree}
                    onBlur={formik.handleBlur("agree")}
                    error={
                      "agree" in formik.errors && "agree" in formik.touched
                    }
                  />
                </div>

                <button
                  className={`btn btn-black btn-request `}
                  type="button"
                  disabled={
                    !formik.dirty || formik.isSubmitting || !formik.isValid
                  }
                  onClick={formik.submitForm}
                >
                  <Trans i18nKey="Common.Create" />
                </button>
              </div>
            ) : null}
          </div>
        </Column>
      </Row>
    </Grid>
  );
};
